export default [
  {
    title: '规则ID',
    key: 'id',
    width: 64
  },
  {
    title: '开关',
    key: 'state',
    width: 50
  },
  {
    title: '规则名称',
    key: 'name',
    width: 152
  },
  {
    title: '触发条件',
    key: 'ruleDesc',
    width: 160
  },
  {
    title: '提醒类型/时间',
    key: 'alertType',
    width: 140
  },
  {
    title: '提醒人员',
    key: 'alertOpNames'
  },
  {
    title: '媒体',
    key: 'mediaNames',
    width: 140
  },
  {
    title: '游戏组',
    key: 'gameGroupNames',
    width: 200,
    overflow: true
  },
  {
    title: '创建人',
    key: 'createOpName',
    width: 64
  },
  {
    title: '最后操作人',
    key: 'updateOpName',
    width: 84
  },
  {
    title: '更新时间',
    key: 'updateTime',
    width: 140
  },
  {
    title: '最后暂停/启动时间',
    key: 'lastRpTime',
    width: 140
  },
  {
    title: '操作',
    key: 'control',
    width: 104
  }
]
